import { render, staticRenderFns } from "./updatePassword.vue?vue&type=template&id=22238785&scoped=true&"
import script from "./updatePassword.vue?vue&type=script&lang=js&"
export * from "./updatePassword.vue?vue&type=script&lang=js&"
import style0 from "./updatePassword.vue?vue&type=style&index=0&id=22238785&prod&lang=less&scoped=true&"
import style1 from "./updatePassword.vue?vue&type=style&index=1&id=22238785&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22238785",
  null
  
)

export default component.exports